import { inject, Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Factory } from '../factory';
import {
  IShoppingCartForm,
  IShoppingCartFormData,
} from '../../entities/shopping-cart-entity';
import { IShoppingCart } from '@web/dtos';

@Injectable({
  providedIn: 'root',
})
export class ShoppingCartFactoryService extends Factory<
  IShoppingCartForm,
  IShoppingCart
> {
  private readonly formBuilder: FormBuilder = inject(FormBuilder);

  buildEntity(form: FormGroup<IShoppingCartForm>): IShoppingCart {
    const shoppingCart: IShoppingCartFormData =
      form.getRawValue() as IShoppingCartFormData;

    const newShoppingCart: IShoppingCart = {
      id: shoppingCart.id,
      showVat: shoppingCart.showVat,
    };

    this.removeNullIds(newShoppingCart);
    return newShoppingCart;
  }

  buildForm(entity: IShoppingCart): FormGroup<IShoppingCartForm> {
    return this.formBuilder.group({
      id: this.formBuilder.nonNullable.control(entity?.id),
      showVat: this.formBuilder.nonNullable.control<boolean>(
        entity?.showVat ?? true,
        [Validators.required]
      ),
    });
  }
}
